<template>
  <tr>
    <td class="v-align-middle" :data-label="$t('models.time_code.name')">{{ timeCode.name }}</td>
    <td class="v-align-middle" :data-label="$t('models.time_code.start_time')">{{ timeCode.start_time }}</td>
    <td class="v-align-middle" :data-label="$t('models.time_code.end_time')">{{ timeCode.end_time }}</td>
    <td class="v-align-middle" :data-label="$t('models.time_code.effective_work_minutes')">{{ effective_work_time }}</td>
    <td class="p-t-5 p-b-5 v-align-middle">
      <div class="btn-toolbar flex-wrap">
        <div class="btn-group">
          <router-link v-if="$can('update', timeCode)" :to="{ name: 'EditTimeCode', params: { entity_id: timeCode.entity_id, time_code_id: timeCode.id }}" class="btn btn-icon">
            <i class="fa fa-edit"></i>
          </router-link>
          <a href="#" v-if="$can('delete', timeCode)" class="btn btn-icon-dark" @click.prevent="deleteTimeCode">
            <i class="fa fa-trash-o"></i>
          </a>
        </div>
      </div>
    </td>
  </tr>
</template>

<script type="text/javascript">
  import { convertMinutesToDurationTime } from '@/helpers/timeCodes'
  import { mapActions } from 'vuex'

  export default {
    name: 'TimeCodeRow',
    props: ['timeCode'],
    computed: {
      effective_work_time(){
        return convertMinutesToDurationTime(this.timeCode.effective_work_minutes)
      }
    },
    methods: {
      ...mapActions({
        checkPermissions: 'timeCodes/checkPermissions',
        delete: 'timeCodes/delete'
      }),
      deleteTimeCode() {
        this.checkPermissions(this.timeCode.id).then(abilities => {
          if(abilities['can_delete']) {
            this.$dialog.confirm(this.$t('messages.delete_confirmation', {'resource': this.$i18n.t('resources.timeCode'), 'name': this.timeCode.name}))
            .then(() => {
              this.delete(this.timeCode)
            })
            .catch(() => {});
          }
          else {
            this.$dialog.alert(this.$t('TimeCodes.undeletable_notice_offer'))
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/timeCodes/TimeCodesTableRow.vue